import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService
    ) {}

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem(
                'Dashboard',
                'Pages.Administration.Host.Dashboard',
                'flaticon-line-graph',
                '/app/admin/hostDashboard'
            ),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
           
            new AppMenuItem('PageInfos', 'Pages.PageInfos', 'flaticon-responsive', '',[],[
                new AppMenuItem('PageLayouts', 'Pages.PageLayouts', 'flaticon-book', '/app/main/uiPageLayout/pageLayouts'),
            
                new AppMenuItem('PageInfos', 'Pages.PageInfos', 'flaticon-responsive', '/app/main/uiPage/pageInfos'),
                new AppMenuItem('Widgets', 'Pages.Widgets', 'flaticon-layer', '/app/main/uiWidget/widgets'),
                // new AppMenuItem('PageWidgetConfigs', 'Pages.PageWidgetConfigs', 'flaticon-graphic', '/app/main/uiPage/pageWidgetConfigs'),
            
                // new AppMenuItem('PageWidgetConfigCategories', 'Pages.PageWidgetConfigCategories', 'flaticon-interface-1', '/app/main/uiPage/pageWidgetConfigCategories'),
                
                // new AppMenuItem('PageWidgetConfigLinks', 'Pages.PageWidgetConfigLinks', 'flaticon-interface-1', '/app/main/uiPage/pageWidgetConfigLinks'),
                new AppMenuItem('SlugInfos', 'Pages.SlugInfos', 'flaticon-more-v4', '/app/main/uiSlug/slugInfos'),
                new AppMenuItem('MetaTemplateInfos', 'Pages.MetaTemplateInfos', 'flaticon-globe', '/app/main/uiPage/metaTemplateInfos'),
            ]),
            
            new AppMenuItem('WorkFlow', 'Pages.WorkFlowTemplates', 'flaticon2-sort-alphabetically', '',[],[
                new AppMenuItem('WorkFlowTemplates', 'Pages.WorkFlowTemplates', 'flaticon2-sort-alphabetically', '/app/main/workFlow/workFlowTemplates'),
            
                new AppMenuItem('WorkFlowTemplateSteps', 'Pages.WorkFlowTemplateSteps', 'flaticon-share', '/app/main/workFlow/workFlowTemplateSteps'),
                
                new AppMenuItem('WorkFlowTemplateStepOrganizations', 'Pages.WorkFlowTemplateStepOrganizations', 'flaticon-network', '/app/main/workFlow/workFlowTemplateStepOrganizations'),
                
                new AppMenuItem('WorkFlowTemplateStepRoles', 'Pages.WorkFlowTemplateStepRoles', 'flaticon-medal', '/app/main/workFlow/workFlowTemplateStepRoles'),
                
                new AppMenuItem('WorkFlowTemplateStepUsers', 'Pages.WorkFlowTemplateStepUsers', 'flaticon-users', '/app/main/workFlow/workFlowTemplateStepUsers'),
                
                new AppMenuItem('WorkFlowStepByItems', 'Pages.WorkFlowStepByItems', 'flaticon-list-1', '/app/main/workFlow/workFlowStepByItems'),
                
                new AppMenuItem('WorkFlowStepByItemDetails', 'Pages.WorkFlowStepByItemDetails', 'flaticon-menu-2', '/app/main/workFlow/workFlowStepByItemDetails'),
                
                new AppMenuItem('WorkFlowItems', 'Pages.WorkFlowItems', 'flaticon-menu-2', '/app/main/workFlow/workFlowItems'),
            ]),
            
            new AppMenuItem('CategoryInfos', 'Pages.CategoryInfos', 'flaticon-notes', '/app/main/uiCategory/categoryInfos'),
            new AppMenuItem('EventInfos', 'Pages.EventInfos', 'flaticon-event-calendar-symbol', '',[],[
                new AppMenuItem('EventInfos', 'Pages.EventInfos', 'flaticon-event-calendar-symbol', '/app/main/uiCategory/eventInfos'),
                new AppMenuItem('NewsEventRelationses', 'Pages.NewsEventRelationses', 'flaticon-list-3', '/app/main/news/newsEventRelationses'),
            ]),
           
            new AppMenuItem('CustomerNewsInfos', 'Pages.CustomerNewsInfos', 'flaticon-edit-1', '',[],[
                new AppMenuItem('NewsInfos', 'Pages.NewsInfos', 'flaticon-edit-1', '/app/main/news/newsInfos'),

                new AppMenuItem('CustomerNewsInfos', 'Pages.CustomerNewsInfos', 'flaticon-edit-1', '/app/main/news/customerNewsInfos'),
                new AppMenuItem('MyNews', 'Pages.CustomerNewsInfos', 'flaticon-interface-11', '/app/main/news/customerNewsInfos/my'),
                new AppMenuItem('MyPendingNews', 'Pages.CustomerNewsInfos', 'flaticon-user-ok', '/app/main/news/customerNewsInfos/myPending'),
                new AppMenuItem('MyRejectNews', 'Pages.CustomerNewsInfos', 'flaticon-signs-2', '/app/main/news/customerNewsInfos/myReject'),
                new AppMenuItem('MyActionNews', 'Pages.CustomerNewsInfos', 'flaticon-stopwatch', '/app/main/news/customerNewsInfos/myAction'),

                // new AppMenuItem('NewsCategoryRelations', 'Pages.NewsCategoryRelations', 'flaticon-list-3', '/app/main/news/newsCategoryRelations'),
            ]),
            
            new AppMenuItem('LinkInfos', 'Pages.LinkInfos', 'flaticon2-image-file', '/app/main/uiLink/linkInfos'),
            
            
            
            
            
       
            
           
            


            
            
           
            
            
           
            
            
            
           
            new AppMenuItem('ContactInfos', 'Pages.ContactInfos', 'flaticon-multimedia-2', '/app/main/contact/contactInfos'),
            
            
            new AppMenuItem('AiSuppliers', 'Pages.AiSuppliers', 'flaticon-more', '/app/main/ai/aiSuppliers'),
            
            new AppMenuItem('AiModels', 'Pages.AiModels', 'flaticon-more', '/app/main/ai/aiModels'),
            
            new AppMenuItem('AiPrompts', 'Pages.AiPrompts', 'flaticon-more', '/app/main/ai/aiPrompts'),
             new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
            new AppMenuItem(
                'Administration',
                '',
                'flaticon-interface-8',
                '',
                [],
                [
                    new AppMenuItem(
                        'OrganizationUnits',
                        'Pages.Administration.OrganizationUnits',
                        'flaticon-map',
                        '/app/admin/organization-units'
                    ),
                    new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                    new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                    new AppMenuItem(
                        'Languages',
                        'Pages.Administration.Languages',
                        'flaticon-tabs',
                        '/app/admin/languages',
                        ['/app/admin/languages/{name}/texts']
                    ),
                    new AppMenuItem(
                        'AuditLogs',
                        'Pages.Administration.AuditLogs',
                        'flaticon-folder-1',
                        '/app/admin/auditLogs'
                    ),
                    new AppMenuItem(
                        'Maintenance',
                        'Pages.Administration.Host.Maintenance',
                        'flaticon-lock',
                        '/app/admin/maintenance'
                    ),
                    new AppMenuItem(
                        'Subscription',
                        'Pages.Administration.Tenant.SubscriptionManagement',
                        'flaticon-refresh',
                        '/app/admin/subscription-management'
                    ),
                    new AppMenuItem(
                        'VisualSettings',
                        'Pages.Administration.UiCustomization',
                        'flaticon-medical',
                        '/app/admin/ui-customization'
                    ),
                    new AppMenuItem(
                        'WebhookSubscriptions',
                        'Pages.Administration.WebhookSubscription',
                        'flaticon2-world',
                        '/app/admin/webhook-subscriptions'
                    ),
                    new AppMenuItem(
                        'DynamicProperties',
                        'Pages.Administration.DynamicProperties',
                        'flaticon-interface-8',
                        '/app/admin/dynamic-property'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Host.Settings',
                        'flaticon-settings',
                        '/app/admin/hostSettings'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Tenant.Settings',
                        'flaticon-settings',
                        '/app/admin/tenantSettings'
                    ),
                    new AppMenuItem(
                        'Notifications',
                        '',
                        'flaticon-alarm',
                        '',
                        [],
                        [
                            new AppMenuItem(
                                'Inbox',
                                '',
                                'flaticon-mail-1',
                                '/app/notifications'
                            ),
                            new AppMenuItem(
                                'MassNotifications',
                                'Pages.Administration.MassNotification',
                                'flaticon-paper-plane',
                                '/app/admin/mass-notifications'
                            )   
                        ]
                    )
                ]
            ),
            new AppMenuItem(
                'DemoUiComponents',
                'Pages.DemoUiComponents',
                'flaticon-shapes',
                '/app/admin/demo-ui-components'
            ),
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }
        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
